module.exports = __webpack_public_path__ + "img/pic_yashua1.10e04f99.png";